function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 9V1H24V9",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28 17V9H22H9H4C2.343 9 1 7.657 1 6V27C1 29.209 2.791 31 5 31H28V23",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M31 23H24C22.343 23 21 21.657 21 20C21 18.343 22.343 17 24 17H31V23Z",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7 3H4C2.343 3 1 4.343 1 6C1 7.657 2.343 9 4 9",
  stroke: "#A0AEC0",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Wallet.40597153.svg";
export { ForwardRef as ReactComponent };